import React from 'react'
import PropTypes from 'prop-types'
import { observable, computed, transaction } from 'mobx'
import { observer } from 'mobx-react'
import {
  Button, Tab, FormControl, Row, Col, Nav, NavItem, NavDropdown, MenuItem, FormGroup, HelpBlock
} from 'react-bootstrap'
import SugestingInput from './suggesting_input'
import TextInput from 'bstrap-react-mobx-admin/input/text'

@observer
export default class I18nInput extends React.Component {
  static propTypes = {
    attrs: PropTypes.object,
    errors: PropTypes.object,
    onAdd: PropTypes.func.isRequired,
    onRemove: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    InputComponent: PropTypes.string,
    optionsMap: PropTypes.object.isRequired,
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    attrFilter: PropTypes.func
  }

  @observable activeTab = 0

  constructor (props) {
    super(props)
    const { attrs, onAdd, tablang } = this.props

    if (attrs && tablang) {
      if (!attrs.find(i => i.lang === tablang)) {
        onAdd(tablang)
      }

      const valueFromLang = tablang && attrs &&
        attrs.find((i, k) => i.lang === tablang && (i.k = k))

      if (valueFromLang && valueFromLang.k) {
        this.activeTab = valueFromLang.k
      }
    }
  }

  render () {
    const self = this
    let {
      store, attrs, InputComponent, optionsMap, name, label, language,
      onChange, onAdd, onRemove, attrFilter, attr, errors, validationSuccess, disabled,
      rows, assetRefs, assetRefsKey
    } = this.props

    InputComponent = InputComponent || 'input'
    attrs = (attrFilter && attrs) ? attrs.filter(attrFilter) : attrs

    const opts = optionsMap.has('FilmCargoLanguages')
      ? optionsMap.get('FilmCargoLanguages')
      : optionsMap.get('Languages')
    const errorText = errors ? errors.get(attr) : undefined
    const validationState = errorText ? 'error' : (validationSuccess ? 'success' : null)
    const inputStyles = InputComponent === 'textarea' ? { minWidth: '100%', maxWidth: '100%', minHeight: '5em' } : {}
    const valueFromLang = language && attrs && attrs.find(i => i.lang === language && i.name === name)

    function _renderAddDropdown (availPlatforms) {
      const info = observable({
        inputval: '',
        get availableOptions () {
          return _getUniqueOpts()
        }
      })

      function _isMatching (opt, val) {
        const matchVal = opt.text.toLowerCase().indexOf(val.toLowerCase()) != -1
        const selected = attrs && attrs.find((i) => opt.value === i.lang)
        return matchVal && !selected
      }

      function _getUniqueOpts () {
        return info.inputval ? opts.filter((i) => {
          return _isMatching(i, info.inputval)
        }) : []
      }

      return opts.length > 0 && (
        <SugestingInput info={info} options={opts}
          onSelect={(opt) => handleAdd(opt)} isMatching={_isMatching}
          placeholder={'e.g., eng, cze, spa...'} />
      )
    }

    function switchTab (tabId) {
      self.activeTab = tabId
    }

    function handleAdd (opt) {
      onAdd(opt.value)

      const attrsLengthEditor = store
        ? (store.cv.entityname === 'films' && 1) || (store.cv.entityname === 'persons' && 0)
        : 0
      self.activeTab = (attrs.length - 1) + attrsLengthEditor
    }

    return (
      <FormGroup validationState={validationState}>
        {label && <label className='control-label' htmlFor={assetRefsKey || name}>{label}</label>}
        {language
          ? <FormControl style={inputStyles}
            componentClass={InputComponent}
            inputRef={assetRefsKey ? el => { assetRefs[assetRefsKey] = el } : undefined}
            id={assetRefsKey || name} name={assetRefsKey || name}
            value={(valueFromLang && valueFromLang.value) || ''}
            onChange={evt => onChange(language, evt.target.value)}
            rows={rows} disabled={disabled} />
          : <Tab.Container id={name}
            activeKey={this.activeTab > attrs.length - 1 ? attrs.length - 1 : this.activeTab}
            onSelect={switchTab}>
            <Row className='clearfix' style={{ overflow: 'hidden', width: '99%' }}>
              <Col sm={12}>
                <Nav bsStyle='tabs'>
                  {
                    attrs && attrs instanceof Array && attrs.map((attr, idx) => (
                      <NavItem eventKey={idx} key={idx} >
                        <span className='add-rmargin'>{attr.lang}</span>
                        {attr.lang !== 'en' && !disabled &&
                            <Button className='btn btn-default btn-xs' onClick={() => onRemove(attr)}>
                              <span className='glyphicon glyphicon-remove' />
                            </Button>
                        }
                      </NavItem>
                    ))
                  }
                </Nav>
              </Col>
              <Col sm={12}>
                <Tab.Content>
                  {
                    attrs && attrs instanceof Array && attrs.map((attr, idx) => {
                      return (
                        <Tab.Pane key={idx} eventKey={idx}>
                          <FormControl style={inputStyles} rows={rows}
                            componentClass={InputComponent} value={attr.value} onChange={(evt) => {
                              onChange(attr.lang, evt.target.value)
                            }} disabled={disabled} />
                        </Tab.Pane>
                      )
                    })
                  }
                </Tab.Content>
                {!disabled && _renderAddDropdown()}
              </Col>
            </Row>
          </Tab.Container>
        }
        {errorText ? <HelpBlock>{errorText}</HelpBlock> : null}
      </FormGroup>
    )
  }
}
